export default __webpack_public_path__ + "static/media/add-icon-min.c8ab0e31.svg";